<template>
  <WidgetGraphCard
    :error="!!error"
    :loading="loading"
    hide-table-btn
    @click:refresh="refresh"
  >
    <template #title>
      {{ $t("widgets.turnoverGraph.title") }}
    </template>

    <template #graph>
      <apexchart
        width="100%"
        height="200"
        type="bar"
        :options="options"
        :series="series"
      ></apexchart>
    </template>
  </WidgetGraphCard>
</template>
<script>
import { times } from "lodash";
import { computed } from "vue-demi";
import { format, subMonths } from "date-fns";
import * as chroma from "chroma-js";

import { abbreviateNumber } from "@/utils/number";

import { useWidgetApi } from "@/composables/api/widget";

import WidgetGraphCard from "./WidgetGraphCard.vue";
import { useI18n } from "@/composables/i18n";
import { useDateLocale } from "@/composables/date";

export default {
  components: { WidgetGraphCard },

  props: {
    hover: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const { t } = useI18n();
    const dateLocale = useDateLocale();

    const { lastUpdate, data, loading, error, execute } = useWidgetApi(
      "/dashboard/turnover/graph"
    );

    const totalMonth = 10;

    const options = computed(() => ({
      chart: {
        stacked: true
      },
      title: {
        text: t("widgets.turnoverGraph.graphTitle"),
        floating: true,
        align: "center",
        style: {
          fontWeight: 300
        }
      },
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      colors: [
        ({ seriesIndex: index }) => {
          const color = chroma
            .hsl((index * 360) / series.value.length, 0.8, 0.6)
            .hex();
          return color;
        }
      ],
      xaxis: {
        categories: times(totalMonth, i => {
          return format(subMonths(new Date(), totalMonth - i), "MMM", {
            locale: dateLocale.value
          });
        })
      },
      yaxis: {
        labels: {
          formatter: v => abbreviateNumber(v)
        }
      }
    }));

    const series = computed(() => {
      if (!data.value) return [];

      return data.value.series.map(s => ({
        name: s.name,
        data: s.data.map(d => d.value).reverse()
      }));
    });

    return {
      options,
      series,
      data,
      lastUpdate,
      loading,
      error,
      refresh: execute
    };
  }
};
</script>
<style></style>
